import registerWebComponent from '../registerWebComponent.js';
export default async () => {
  const {
    EBWebFeedbackCTA
  } = await import('https://web-common.prod.connected-biking.cloud/web/elements/EBWebFeedbackCTA.js');
  const {
    EBWebFeedbackModal
  } = await import('https://web-common.prod.connected-biking.cloud/web/elements/EBWebFeedbackModal.js');
  registerWebComponent('ebweb-feedback-cta', EBWebFeedbackCTA);
  registerWebComponent('ebweb-feedback-modal', EBWebFeedbackModal);
};